import { ACCOUNTING_REPORT_LABELS } from "@common/types/reports/report-type";
import { SAVE_REPORT_SETTINGS_REPORT_KEYS } from "@common/schemas/domains/reportSettings/save-report-settings.schema";
import { REPORT_SETTINGS_DEFAULT_REPORT_KEY } from "@common/types/reports/report-settings-report-key";
import { ReportSettingsTarget } from "@common/helpers/report-settings/report-setting-candidates";

type SaveReportKey = (typeof SAVE_REPORT_SETTINGS_REPORT_KEYS)[number];
type ConcreteSaveReportKey = Exclude<
    SaveReportKey,
    typeof REPORT_SETTINGS_DEFAULT_REPORT_KEY
>;

interface ReportOption<T extends SaveReportKey> {
    value: T;
    label: string;
    tooltip?: string;
}

const REPORT_DEFAULT_LABEL = "Default";

export const REPORT_DEFAULT_LABELS: Record<
    ReportSettingsTarget["kind"],
    string
> = {
    template: "Template default",
    workspace: "Client default",
    entity: "Entity default",
};

export const REPORT_DEFAULT_TOOLTIPS: Record<
    ReportSettingsTarget["kind"],
    string
> = {
    template:
        "Set the default for every report in this template. Select a specific report to override its settings.",
    workspace:
        "Set the default for every report in this client. Select a specific report to override its settings.",
    entity: "Set the default for every report in this entity. Select a specific report to override its settings.",
};

export const REPORT_SETTINGS_PREVIEW_OPTIONS: Array<
    ReportOption<ConcreteSaveReportKey>
> = SAVE_REPORT_SETTINGS_REPORT_KEYS.flatMap((reportKey) =>
    reportKey === REPORT_SETTINGS_DEFAULT_REPORT_KEY
        ? []
        : [{ value: reportKey, label: ACCOUNTING_REPORT_LABELS[reportKey] }],
);

export const REPORT_SETTINGS_REPORT_OPTIONS: Array<
    ReportOption<SaveReportKey>
> = [
    {
        value: REPORT_SETTINGS_DEFAULT_REPORT_KEY,
        label: REPORT_DEFAULT_LABEL,
    },
    ...REPORT_SETTINGS_PREVIEW_OPTIONS,
];
